import React from "react";
import './Body8.css';
import {Link} from "react-router-dom"
import picture212 from './source/picture212.png'
import picture206 from './source/picture206.png'
import picture207 from './source/picture207.png'
import picture208 from './source/picture208.png'
import picture209 from './source/picture209.png'
import picture210 from './source/picture210.png'
import picture211 from './source/picture211.png'


function Body8() {

  return (
    <div className="body8">
      <div className="body8-box1">
        <div className="body8-box2">
          <div className="body8-box3">Zlín</div>
          <div className="body8-box5"><div className="body8-box4"></div></div>
          <div className="body8-box6">
          <img className="body8-box6-picture" src={picture212} alt="picture1"/>
          <img className="body8-box6-picture" src={picture207} alt="picture1"/>
          <img className="body8-box6-picture" src={picture211} alt="picture1"/>
          <img className="body8-box6-picture" src={picture208} alt="picture1"/>
          <img className="body8-box6-picture2" src={picture206} alt="picture1"/>          
          <img className="body8-box6-picture2" src={picture209} alt="picture1"/> 
          <img className="body8-box6-picture2" src={picture210} alt="picture1"/>
          </div>
          <div className="body8-box8"><div className="body8-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body8;
